import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutHtmlStyledContent: FunctionComponent<Props> = ({ html, className }) => {
    return (
        <StyledComponent
            className={classnames(
                'layout-html-styled-content',
                className,
            )}
        >
            <div dangerouslySetInnerHTML={{ __html: html }} />
        </StyledComponent>
    );
};

export default LayoutHtmlStyledContent;
